var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUrgent = function SvgUrgent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF4D4F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.333 2.68v10.654M2.666 5.346l2.667-2.668 2.668 2.668M10.667 7.334v6.04M8 10l2.667-2.666L13.334 10"
  })));
};
export { SvgUrgent as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMTcwYmVlYjAzMzRlZmEwNjUyMjQ1NjM3ZmZjMjg5YTQuc3ZnIjs=";